import { render } from "./EditTransaction.vue?vue&type=template&id=b0a71bac&scoped=true"
import script from "./EditTransaction.vue?vue&type=script&lang=js"
export * from "./EditTransaction.vue?vue&type=script&lang=js"

import "./EditTransaction.vue?vue&type=style&index=0&id=b0a71bac&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0a71bac"]])

export default __exports__